import { DismissibleDialog } from '@scoir/modals'

import { Message } from '../types'
import AudienceDetails from './AudienceDetails'
import MessageDetails from './MessageDetails'

const { Body, Footer } = DismissibleDialog

const { CloseButton } = Footer

type PreviewModalProps = {
  outreachItem: Message
  show: boolean
  onClose: () => void
}

// TODO: RE-WORK PREVIEW MODAL TO NEW UI - HE-296
const PreviewModal = ({ outreachItem, show, onClose }: PreviewModalProps) => (
  <DismissibleDialog
    open={show}
    scroll="paper"
    aria-label="View Outreach Message"
    headerText="Message Preview"
    onClose={onClose}
  >
    <Body withBackgroundColor>
      <AudienceDetails message={outreachItem} />
      <MessageDetails message={outreachItem} />
    </Body>
    <Footer>
      <CloseButton variant="contained">Close</CloseButton>
    </Footer>
  </DismissibleDialog>
)

export default PreviewModal
